import {
  getTickets
} from "./chunk-H2CYOPFA.mjs";
import {
  __spreadProps,
  __spreadValues
} from "./chunk-DFMI36TU.mjs";

// src/hooks/wbk/events/tickets.ts
import { useInfiniteQuery } from "@tanstack/react-query";
var useGetTickets = (props, options) => {
  return useInfiniteQuery(__spreadProps(__spreadValues({
    queryKey: ["getTickets", props],
    queryFn: ({ pageParam = 1 }) => getTickets(__spreadProps(__spreadValues({}, props), { page: pageParam })),
    getNextPageParam: (lastPage, _allPages, lastPageParam) => {
      const meta = lastPage.meta;
      const total_pages = Math.ceil(meta.total / meta.per_page);
      return meta.current_page < total_pages ? lastPageParam + 1 : void 0;
    }
  }, options), {
    select: (data) => {
      var _a, _b, _c, _d;
      const pages = data.pages;
      const isEvent = props.ticketType === "event";
      const meta = (_b = (_a = pages == null ? void 0 : pages.slice(-1)) == null ? void 0 : _a[0]) == null ? void 0 : _b.meta;
      if (isEvent) {
        const event = ((_c = pages == null ? void 0 : pages[0]) == null ? void 0 : _c.data).event;
        const tickets = pages.flatMap((page) => page.data.event_ticket);
        return { event, meta, tickets };
      } else {
        const event = ((_d = pages == null ? void 0 : pages[0]) == null ? void 0 : _d.data).season;
        const tickets = pages.flatMap((page) => page.data.season_ticket);
        return { event, meta, tickets };
      }
    },
    initialPageParam: 1,
    staleTime: Infinity
  }));
};

export {
  useGetTickets
};
//# sourceMappingURL=chunk-43QKBPKD.mjs.map